import UtilSP from 'SATPROF_UTILS/UtilSP.ts';
import TimingInfo from 'SATPROF_LIBRARY/DropinSupervisor/timing-info';
//import THREE from 'THREE_BOOTSTRAP';
//import { Vector2 } from 'three';

export default class Oscilloscope4 extends createjs.Container {
	/*
	Functions and methods:
	
	loadData1(arr, ts, nn); // data array, time step, number of points
	loadData2(arr, ts, nn); // data array, time step, number of points
	reset()
	clearOldTrace()
	reLoadData1(arr, nn)
	getData1(); // Returns array 1
	getData2(); // Returns array 2
	Npts
	marginPct
	showScreenBackground
	nVdivs
	nTdivs
	NptsSeg
	tStep
	showDot
	dot1Color
	gapSize
	trace1Color
	trace2Color
	gridColor
	screenBackgroundColor
	gridType
	pointsPerSweep
	showPreviousTraces
	timeScaleFactor
	numberOfTraces
	ic     r/o
	autoSweep
	autoUpdate
	singleSweep
	setLabelPos(i, xpos, ypos )
	setLabelPosByValue(i, tpos, vpos )
	hideAllLabels(
	updateAllLabelFormats()
	regenerateGraphics()
	recalcParams()
	triggerSweep()
	 update()
	 
	*/	
	
	
	/*
	For examples embedded in XYplot, see SymbolLibraryXYPlot, iDTransmit4
	
	Must be linked to a symbol that contains a border rectangle that is exactly 300 x 150 pixels, with its lower left corner at 0,0.
	
	Methods
	-------
		
		
	 trigger()
	 	Resets the sweep and starts it
		
	Instance properties that must be externally set (THESE ARE WRONG)
		bDot			true if a trace dot should be shown.
	 	aValues1		Data buffer memory
	 	_tBegin		Absolute start time of the data.
		_tStep		Time step of the data.
		iTraceGap 	Pixels in gap between current and prev traces
		_tSweep		Sweep time setting
	 	_tStart		Abs time to start the sweep (starting point of the data for the current sweep)
		//_tCurrent	The current absolute time
	 	nVperDiv	Volts per div
		nVcenter	Volts at the center line
	 	_nVdivs		Number of divisions on the voltage scale
	 	_nTdivs		Number of divisions on the time scale
		autoUpdate
		_singleSweep
		timeScaleFactor
		
	           aValues1
	    |     --------                       ------------        ----|
	    |   /          \         --        /              \    /     |
	    |--             \      /    \     O                ----      |
	    |                ------      \   /                           |
	    |                             ---                            |
	    |____________________________________________________________|
		|                        |        |                | 
		0                      i1curr     ic             i2curr     Npts   index into aValues1
		                         0       icSeg           NptsSeg
	    0                        0    _tCurrent           tEnd         absolute time. Step size = _tStep
	                             0                       tSweep         time into sweep
		0					     0  _tCurrentReal      _tSweepReal
						    _tStartReal
  
	  															
	triggerSweep()
	   Draws trace and sets up masks for the next segment.
	update()
	   Moves the masks based on the current time.
	   Fires endOfSweep event if time is past the end of the segment.
	
	Typical usage:
	Call loadData1, loadData2. (loads aValues1 and aValues2 and stes Npts).
	Set _tStep (time between samples).
	Set NptsSeg
	Set timeScaleFactor.
	
	Call triggerSweep() to start the sweep.  Set sweeping = true.
		Calc _tSweep and _tSweepReal, _tStart, 
		Initialize i1curr = 0, ic = 0, icSeg = 0, i2curr = NptsSeg-1
	onEnterFrame, if sweeping = true.
		Based on the new elapsed time, calc new _tCurrent, ic, icSeg, _tCurrentReal
		if icSeg >= NptsSeg:
		   	Fire endOfSweep event.
			if singleSegment = true:
				Reset icSeg, etc.
			else
				Set icSeg to beginning of next segment, or back to beginning if there are not enough points left in aValues1.
			if singleSweep is true, set sweeping = false.
		Move the mask and dot.   
	   
	
		
	 */
	public _freeze:boolean = false;
	public nVcenter:number = 0;
	public nVcenter2:number = 0;
	public nVperDiv:number = 1;
	public nVperDiv2:number = 1;
	private _nVdivs = 10;
	private _nTdivs = 10;
	public _tStartReal:number = 0;
	private _tSweep:number = 0.2;
	public _tStep:number = 0.001;
	private _nSegments = 1;
	//private _tStart:number = 0;
	public _tCurrent:number = 0;
	public bDot = true;
	public iTraceGap = 10; // Pixels in gap between current and prev traces
	public iTraces = 1;  // No of traces
	public _tCurrentReal;
	public tRealAbsTrig;
	private _timeScaleFactor = 1;
	private _autoUpdate = false;
	private _autoSweep = false;
	private _singleSweep = false;
	private _firstSweepForThisData = true;
	
	public i1curr:number = -1;
    public i2curr:number; // Start and end indices in aValues1 of the current trace
	public i1prev:number
    public i2prev:number; // Start and end indices in aValues1 of the previous trace
	private _ic = 0; // Index into aValues1 of the point with the dot on it.
	private _icSeg = 0;
	private _iSeg = 0; // Which segment we are in
	private _showPreviousTraces = true;
	private _sweeping = false;

	private _gridType:string = "Outline"; // or "Full"
	private gridDivsX = this._nTdivs;
	private gridDivsY = this._nVdivs;
	public screenX1:number
    public  screenY1:number; 
	public screenWidth = 300; //this._width; // Width
	public screenHeight = 150; //this._height; // Height
	private _marginPct = 5;


	public gridX1:number;
	public gridY1:number;
	public gridWidth:number;
	public gridHeight:number;
	private clipToDrawIn:createjs.Shape;
	
	private scopeScreen:createjs.Shape
    private scopeGrid:createjs.Shape
    private scopeDot1:createjs.Shape;
	private scopeTraceCurr:createjs.Shape
    private scopeTracePrev:createjs.Shape;
	private scopeTrace2Curr:createjs.Shape
    private scopeTrace2Prev:createjs.Shape;
	private maskCurr:createjs.Shape
    private maskPrev:createjs.Shape;
	private maskCurr2:createjs.Shape
    private maskPrev2:createjs.Shape;
	private maskDot:createjs.Shape;
	public startedNewSweep = false;
	
	private _trace1Color:string = "green";
	private _trace2Color:string = "green";
	private _gridColor:string = "red";
	private _dot1Color:string = "green";
	private _screenBackgroundColor:string = "#101010";
	private _showScreenBackground = true;



	private aValues1:Array<number>;
	private aValues2:Array<number>;
	private _Npts = 128;
	private _NptsSeg = 128;
	
	public labels:Array<createjs.Text>; // Array of text field objects.
	public _labelFont:string = "14px Arial";
	public _labelColor:string = "black";
    public sweepTimer:TimingInfo;
	public ready = false;
   
   constructor(){
        super();
		this.scopeScreen = new createjs.Shape(); this.addChild(this.scopeScreen);
		this.scopeTraceCurr = new createjs.Shape(); this.addChild(this.scopeTraceCurr);
		this.scopeTracePrev = new createjs.Shape(); this.addChild(this.scopeTracePrev);
		this.scopeTrace2Curr = new createjs.Shape(); this.addChild(this.scopeTrace2Curr);
		this.scopeTrace2Prev = new createjs.Shape(); this.addChild(this.scopeTrace2Prev);
		this.scopeGrid = new createjs.Shape(); this.addChild(this.scopeGrid);
		this.scopeDot1 = new createjs.Shape(); this.addChild(this.scopeDot1);
		this.maskCurr = new createjs.Shape(); this.addChild(this.maskCurr); 
		this.maskCurr2 = new createjs.Shape(); this.addChild(this.maskCurr2); 
		this.maskPrev = new createjs.Shape(); this.addChild(this.maskPrev); 
		this.maskPrev2 = new createjs.Shape(); this.addChild(this.maskPrev2); 
		this.maskDot = new createjs.Shape();  this.addChild(this.maskDot); 

		this.scopeDot1.mask = this.maskDot;

		this.labels = [];
        let maxLabels = 10;
		for (let i=0; i<maxLabels; i++){
			this.labels[i] = new createjs.Text();
			this.addChild( this.labels[i] );
			this.labels[i].font = this._labelFont;
			this.labels[i].text = "";
            this.labels[i].color = UtilSP.c2rgba(this._labelColor);
		}
		
		this.aValues1 = [];
		this.aValues2 = [];
		///hideAllLabels();
		this.recalcParams();
		this.regenerateGraphics();
		this._autoUpdate = true; // Use setter
        this.sweepTimer = new TimingInfo();
        this.sweepTimer.reset();
		this.ready = true;        
   }
	public loadData1(arr:Array<number>, ts:number, nn:number){
		this._tStep = ts;
		this.aValues1 = arr;
		this._Npts = nn;
		this._NptsSeg = this._Npts;
		this.recalcParams();
		this.reset();
	}
	public reset(){
		this._ic = 0;
		this._iSeg = 0;
		//trace("in scope reset.");
	}
	public clearOldTrace(){
		this._firstSweepForThisData = true;
	}
	public reLoadData1(arr:Array<number>, nn:number){
		this.aValues1 = arr;
		this._Npts = nn;
		this.recalcParams();
	}
	public getData1(){
		return this.aValues1;
	}
	public set Npts(val){ 
		this._Npts = val; 
		this._NptsSeg = this._Npts;
		this.recalcParams();
		this.reset();
	}
	public get Npts(){ return this._Npts; };
	
	
	public set marginPct(val){
		this._marginPct = val;
		this.regenerateGraphics();
	}
	public get marginPct(){
		return this._marginPct;
	}
	public set showScreenBackground(val){
		this._showScreenBackground = val;
		this.regenerateGraphics();
	}
	public get showScreenBackground(){
		return this._showScreenBackground;
	}
	public set nVdivs(val){
		this._nVdivs = val;
		this.gridDivsY = this._nVdivs;
		this.recalcParams();
		this.createGrid();
	}
	public get nVdivs(){
		return this._nVdivs;
	}
	public set nTdivs(val){
		this._nTdivs = val;
		this.gridDivsX = this._nTdivs;
		this.recalcParams();
		this.createGrid();
	}
	public get nTdivs(){
		return this._nTdivs;
	}
	
	public set NptsSeg(val){ this._NptsSeg = val; this.recalcParams();};
	public get NptsSeg(){ return this._NptsSeg; };
	
	public set tStep(val){ this._tStep = val; this.recalcParams();};
	public get tStep(){ return this._tStep; };
	
	public loadData2(arr, ts, nn){
		this._tStep = ts;
		this.aValues2 = arr;
		this._Npts = nn;
		this._NptsSeg = this._Npts;
		this.recalcParams();
		this.reset();
	}
	public getData2(){
		return this.aValues2;
	}
	public set showDot(val){
		this.bDot = val;
	}
	public get showDot(){
		return this.bDot;
	}
	
	public set dot1Color(val:string){
		this._dot1Color = val;
		this.makeDot1();
	}
	public get dot1Color(){
		return this._dot1Color;
	}
	public set gapSize(val:number){
		this.iTraceGap = val;
	}
	public get gapSize(){
		return this.iTraceGap;
	}
	public set trace1Color(val:string){
		this._trace1Color = val;
	}
	public get trace1Color(){
		return this._trace1Color;
	}
	public set trace2Color(val:string){
		this._trace2Color = val;
	}
	public get trace2Color(){
		return this._trace2Color;
	}
	public set gridColor(val:string){
		this._gridColor = val;
		this.createGrid();
	}
	public get gridColor(){
		return this._gridColor;
	}
	
	public set screenBackgroundColor(val:string){
		this._screenBackgroundColor = val;
		this.regenerateGraphics();
	}
	public get screenBackgroundColor(){
		return this._screenBackgroundColor;
	}


	public set gridType(val){
		this._gridType = val;
		this.createGrid();
	}
	public get gridType(){
		return this._gridType;
	}
	
	public get pointsPerSweep(){
		return (this.i2curr - this.i1curr);
	}
	public set showPreviousTraces(val){
		this._showPreviousTraces = val;
	}
	public get showPreviousTraces(){
		return this._showPreviousTraces;
	}
	public set timeScaleFactor(val){
		this._timeScaleFactor = val;
		this.recalcParams();
	}
	public get timeScaleFactor(){
		return this._timeScaleFactor;
	}

	public get ic():number{
		let ictemp = this._icSeg  + this._iSeg*this.NptsSeg;
		//trace("Getting ic = "+ictemp+", _icSeg = "+_icSeg+", _iSeg = "+_iSeg+", NptsSeg = "+_NptsSeg);
		return ictemp;
	}
	public set numberOfTraces(val:number){
		this.iTraces = val;
	}
	public get numberOfTraces(){
		return this.iTraces;
	}
	
	public set autoSweep(val:boolean){
		this._autoSweep = val;
		if(val){
			this._sweeping = true;
		}
	}
	public get autoSweep(){
		return this._autoSweep;
	}
	public set autoUpdate(val:boolean){
		this._autoUpdate = val;
	}
	public get autoUpdate(){
		return this._autoUpdate;
	}

	public set singleSweep(val:boolean){
		this._singleSweep = val;
	}
	public get singleSweep(){
		return this._singleSweep;
	}
    public set labelFont(val:string){
        this._labelFont = val;
        this.updateAllLabelFormats();
    }
    public get labelFont(){
        return this._labelFont;
    }
    public set labelColor(val:string){
        this._labelColor = val;
        this.updateAllLabelFormats();
    }
    public get labelColor(){
        return this._labelColor;
    }   

	public setLabelPos(i:number, xpos:number, ypos:number ){
		this.labels[i].x = xpos;// + gridX1;// + gridWidth/2; //nV2PixH(0);
		this.labels[i].y = ypos + this.gridY1 - 20;
	}
	public setLabelPosByValue(i:number, tpos:number, vpos:number ){
		this.labels[i].x = this.nT2Pix(tpos);// + gridX1;// + gridWidth/2; //nV2PixH(0);
		this.labels[i].y = this.nV2Pix(vpos);
		//trace(" placed label "+i+" at pixels "+labels[i].x+", "+labels[i].y+", tpos = "+tpos+", vpos = "+vpos);
	}
	public hideAllLabels(){
		for (let i=0; i<this.labels.length; i++){
			this.labels[i].visible = false;
		}
	}
	public updateAllLabelFormats(){
		for (let i=0; i<this.labels.length; i++){
			this.labels[i].font = this._labelFont;
			this.labels[i].color = this._labelColor;
		}
	}

	public doEveryFrame():void {
		if (this._freeze) { return; };
        if (this._autoUpdate){
		    this.update();
        }
	}	
	
	
	public regenerateGraphics() {
		
		this.screenX1 = 0; //this._x; // LL cornder
		this.screenY1 = 0; //this._y;
		// The grid will be 5% in from the edges.
		this.gridX1 = this.screenX1 + (this._marginPct/100) * this.screenWidth;
		this.gridWidth = ((100-2*this._marginPct)/100) * this.screenWidth;
		this.gridY1 = this.screenY1 - (this._marginPct/100) * this.screenHeight;
		this.gridHeight = ((100-2*this._marginPct)/100) * this.screenHeight;
		
		
		this.scopeScreen.graphics.clear();
		if (this._showScreenBackground){
			this.scopeScreen.graphics.beginFill( UtilSP.c2rgba(this._screenBackgroundColor));
			this.scopeScreen.graphics.moveTo(this.screenX1, this.screenY1);
			this.scopeScreen.graphics.lineTo(this.screenX1 + this.screenWidth, this.screenY1);
			this.scopeScreen.graphics.lineTo(this.screenX1 + this.screenWidth, this.screenY1 - this.screenHeight);
			this.scopeScreen.graphics.lineTo(this.screenX1, this.screenY1 - this.screenHeight);
			this.scopeScreen.graphics.lineTo(this.screenX1, this.screenY1);
			this.scopeScreen.graphics.endFill();
		}
		
		// Now make the scope dot:	
		this.maskDot.graphics.clear();
		this.maskDot.graphics.beginFill( UtilSP.c2rgba( "blue", 0.50));
		this.maskDot.graphics.moveTo(this.screenX1, this.screenY1);
		this.maskDot.graphics.lineTo(this.screenX1 + this.screenWidth, this.screenY1);
		this.maskDot.graphics.lineTo(this.screenX1 + this.screenWidth, this.screenY1 - this.screenHeight);
		this.maskDot.graphics.lineTo(this.screenX1, this.screenY1 - this.screenHeight);
		this.maskDot.graphics.lineTo(this.screenX1, this.screenY1);
		this.maskDot.graphics.endFill();
        this.maskDot.visible = false; ////
		this.makeDot1();
		
		//Make the mask for the current traces:
        // Each mask is 100 units wide and the height of the grid area.
		this.maskCurr.graphics.clear();
		this.maskCurr.graphics.beginFill(UtilSP.c2rgba( "blue", 0.1));
		this.maskCurr.graphics.moveTo(0, this.gridY1);
		this.maskCurr.graphics.lineTo(100, this.gridY1);
		this.maskCurr.graphics.lineTo(100, this.gridY1-this.gridHeight);
		this.maskCurr.graphics.lineTo(0, this.gridY1-this.gridHeight);
		this.maskCurr.graphics.lineTo(0, this.gridY1);
		this.maskCurr.graphics.endFill();
        this.maskCurr.visible = false; ////
		
		this.maskCurr2.graphics.clear();
		this.maskCurr2.graphics.beginFill(UtilSP.c2rgba( "blue", 0.50));
		this.maskCurr2.graphics.moveTo(0, this.gridY1);
		this.maskCurr2.graphics.lineTo(100, this.gridY1);
		this.maskCurr2.graphics.lineTo(100, this.gridY1-this.gridHeight);
		this.maskCurr2.graphics.lineTo(0, this.gridY1-this.gridHeight);
		this.maskCurr2.graphics.lineTo(0, this.gridY1);
		this.maskCurr2.graphics.endFill();
        this.maskCurr2.visible = false; ////
		
		//Make the mask for the previous trace:
		this.maskPrev.graphics.clear();
		this.maskPrev.graphics.beginFill(UtilSP.c2rgba( "red", 0.20));
		this.maskPrev.graphics.moveTo(0, this.gridY1);
		this.maskPrev.graphics.lineTo(100, this.gridY1);
		this.maskPrev.graphics.lineTo(100, this.gridY1-this.gridHeight);
		this.maskPrev.graphics.lineTo(0, this.gridY1-this.gridHeight);
		this.maskPrev.graphics.lineTo(0, this.gridY1);
		this.maskPrev.graphics.endFill();
        this.maskPrev.visible = false; ////
		
		this.maskPrev2.graphics.clear();
		this.maskPrev2.graphics.beginFill(UtilSP.c2rgba( "red", 0.50));
		this.maskPrev2.graphics.moveTo(0, this.gridY1);
		this.maskPrev2.graphics.lineTo(100, this.gridY1);
		this.maskPrev2.graphics.lineTo(100, this.gridY1-this.gridHeight);
		this.maskPrev2.graphics.lineTo(0, this.gridY1-this.gridHeight);
		this.maskPrev2.graphics.lineTo(0, this.gridY1);
		this.maskPrev2.graphics.endFill();
        this.maskPrev2.visible = false; ////
	
	}
	public recalcParams(){
		this._nSegments = Math.floor( this._Npts / this._NptsSeg );
		this._tSweep = this._NptsSeg * this.tStep;
		
	}
	public triggerSweep(){
		// Draw the two traces (curr and prev) and initialize the masks.
		//trace("In Oscilloscope4.triggerSweep(). _iSeg was "+_iSeg);
		// Recalculate common parameters:
		this.recalcParams();
		// Previously we were at segment no. iSeg.  (Initialized at -1)
		
		if (this._iSeg >= this._nSegments){
			// Not enough data left in the buffer to do a whole sweep.
			 this.reset();
		} 
		//trace("Now iSeg = "+_iSeg);
		//this._tStartReal = getTimer()/1000;
        this.sweepTimer.reset();
		
		this._tCurrent = 0;
		//_tEnd = _tBegin + _Npts * _tStep;
		
		this.i1curr = this._iSeg * this._NptsSeg;
		this.i2curr = this.i1curr + this._NptsSeg -1;
		if (this._iSeg == 0 ){
			// We are at the first segment; prev data is the last segment.
			// E.g.  _nSegments = 4, _NptsSeg = 100, i1prev = 300, i2prev = 399
			this.i1prev = (this._nSegments - 1)*this._NptsSeg; 
			this.i2prev = this.i1prev + this._NptsSeg - 1;
		} else {
			this.i1prev = (this._iSeg-1) * this._NptsSeg;
			this.i2prev = this.i1prev + this._NptsSeg - 1;
		}
		this._icSeg = 0;
		//_ic = i1curr;
		this._sweeping = true;

		//trace("  _tCurrent= "+ _tCurrent+", _tSweep= "+ _tSweep +", i1curr = "+i1curr+", i2curr = "+i2curr+", _ic = "+_ic);
		this.scopeTraceCurr.graphics.clear();
		this.scopeTraceCurr.graphics.setStrokeStyle(2); // 2 pts, pure green
		this.scopeTraceCurr.graphics.beginStroke(UtilSP.c2rgba(this._trace1Color, .80)); // 2 pts, pure green
		this.scopeTraceCurr.mask = this.maskCurr;
		
		this.scopeTracePrev.graphics.clear();
		this.scopeTracePrev.graphics.setStrokeStyle(2); // 2 pts, pure green
		this.scopeTracePrev.graphics.beginStroke(UtilSP.c2rgba(this._trace1Color, .80));
		this.scopeTracePrev.mask = this.maskPrev;
		
		this.scopeTrace2Curr.graphics.clear();
		this.scopeTrace2Curr.graphics.setStrokeStyle(2); // 2 pts, 
		this.scopeTrace2Curr.graphics.beginStroke(UtilSP.c2rgba(this._trace2Color, .80)); 
		////this.scopeTrace2Curr.mask = this.maskCurr2;
		
		this.scopeTrace2Prev.graphics.clear();
		this.scopeTrace2Prev.graphics.setStrokeStyle(2); 
		this.scopeTrace2Prev.graphics.beginStroke(UtilSP.c2rgba(this._trace2Color, .80));
		////this.scopeTrace2Prev.mask = this.maskPrev2;

		let i, k, t, s, v1, v2, x1, y1, y2;

		//Reset mask to cover whole trace
		this.maskCurr.x = this.gridX1;
		this.maskCurr.scaleX = 1; //width = this.gridWidth;
		this.maskCurr2.x = this.gridX1;
		this.maskCurr2.scaleX = 1; //width = this.gridWidth;

		//trace("Oscilloscope4.triggerSweep(), 0 V = "+nV2Pix(0)+" pixels");
		//trace("Drawing trace. _firstSweepForThisData = "+_firstSweepForThisData);
		for ( i=this.i1curr; i<=this.i2curr; i++){
			t = this._tStep * (i - this.i1curr); // time into the sweep
			x1 = this.nT2Pix(t);
			v1 = this.aValues1[i];
			v2 = this.aValues2[i];
			y1 = this.nV2Pix(v1);
			y2 = this.nV2Pix(v2);
			//trace("i = "+i+", t = "+t+", v1 = "+v1+", v2 = "+v2+"; x1 = "+x1+", y1 = "+y1);
			if (i==this.i1curr){
				this.scopeTraceCurr.graphics.moveTo(x1, y1);
				if ( this.iTraces == 2 ){
					this.scopeTrace2Curr.graphics.moveTo(x1, y2);
				}
			}else{
				this.scopeTraceCurr.graphics.lineTo(x1, y1);
				if ( this.iTraces == 2 ){
					this.scopeTrace2Curr.graphics.lineTo(x1, y2);
				}
			}
		}
		if ( !this._firstSweepForThisData ){
			// Not the first time.
			//trace("Drawing previous trace; i1prev = "+i1prev+"; i2prev = "+i2prev);
			for ( i=this.i1prev; i<=this.i2prev; i++){
				t = this._tStep * (i - this.i1prev); // time into the sweep
				x1 = this.nT2Pix(t);
				v1 = this.aValues1[i];
				v2 = this.aValues2[i];
				y1 = this.nV2Pix(v1);
				y2 = this.nV2Pix(v2);
				//trace("t = "+t+", "+v+"; "+x+", "+y);
				if (i==this.i1prev){
					this.scopeTracePrev.graphics.moveTo(x1, y1);
					if (this.iTraces == 2){
						this.scopeTrace2Prev.graphics.moveTo(x1, y2);
					}
				}else{
					this.scopeTracePrev.graphics.lineTo(x1, y1);
					if (this.iTraces == 2){
						this.scopeTrace2Prev.graphics.lineTo(x1, y2);
					}
				}
			}
		}
		this._firstSweepForThisData = false;
		//trace("Finished triggerSweep.");
		if (this._iSeg >= this._nSegments-1){
			// Not enough data left in the buffer to do a whole sweep.
			 //trace("Finished sweep, no more segments, resetting.");
			 this.reset();
		} else {
			this._iSeg += 1;
			//trace("Finished sweep, incrementing iSeg to +"+_iSeg);
		}

	}
	/*
	private time2ic( tt){
		//let nDataLength = aValues1.length; 
		let icRet = i1curr + Math.floor( tt / _tStep );
		//icRet = Util3.minmax(icRet, 0, nDataLength-1);
		return icRet;
	}
	*/

	
	public update(){
		// Plot aValues1 starting at _tStart, up to _tCurrent, on the grid.
		//console.log("In Oscilloscope4.update()... ");
		if (!this._sweeping){
			//console.log("  _sweeping = false.  Returning.");
			return;
		}
		
		this._tCurrentReal = this.sweepTimer.elapsedTime; //getTimer()/1000 - this._tStartReal;
		
		this._tCurrent = this._tCurrentReal / this._timeScaleFactor;
		
		this._icSeg = Math.floor( this._tCurrent / this._tStep );
		//trace("  _icSeg = "+_icSeg+", _sweeping = "+_sweeping+", _tCurrent = "+_tCurrent);
		
		if (this._icSeg >= this._NptsSeg ){ //&& !_singleSweep

			this._icSeg = this._NptsSeg-1; // Last point in segment.
			this._ic = this._iSeg*this._NptsSeg + this._icSeg; 
			this._sweeping = false;
			//console.log("  Completed segment sweep.  Throwing event now.");
            const event = new CustomEvent('OSCILLOSCOPE4.END_OF_SWEEP', { detail:{name:this.name} });
            window.dispatchEvent(event);

			if ( this._autoSweep ){
				//trace("  Auto triggering a new sweep now...");
				this.triggerSweep();
			} // Otherwise just stop here and wait for triggerSweep to be called from somewhere else.
			return;
		}
		
		//trace("in Oscilloscope4 "+this.name+" update(): _tCurrent = "+_tCurrent+", _tSweep = "+_tSweep+", i1curr= "+i1curr+", i2curr= "+i2curr+", ic= "+_ic);
		//trace("  In Oscilloscope4 "+this.name+" update(): _iSeg = "+_iSeg+", i1curr= "+i1curr+", i2curr= "+i2curr+", ic= "+_ic);
		
		this._ic = this._iSeg*this._NptsSeg + this._icSeg; 
		//trace("   _ic = "+_ic +", _iSeg = "+_iSeg+", _icSeg = "+_icSeg); 
		let t = this._tStep * (this._icSeg); // time into the sweep
		let x1 = this.nT2Pix(t);
		let v1 = this.aValues1[this._ic];
		let y1 = this.nV2Pix(v1);
		//trace( "Mask width = "+ maskCurr.width +", x = "+maskCurr.x );
		//trace("ic = "+_ic+", t = "+t+", x1 = "+x1+", v1 = "+v1+", y1 = "+y1);
		this.maskCurr.x = this.gridX1;
		this.maskCurr.scaleX = (this.gridWidth/100) * (x1 - this.gridX1)/this.gridWidth;
		this.maskCurr2.x = this.gridX1;
		this.maskCurr2.scaleX = this.maskCurr.scaleX; //(x1 - this.gridX1)/this.gridWidth;
		
		// This is for the prev mask
		if (this._showPreviousTraces){
			let gap = this.iTraceGap;
			this.maskPrev.x = x1 + gap;
			this.maskPrev.scaleX = (this.gridWidth/100) * (this.gridWidth - (x1 - this.gridX1) - gap)/this.gridWidth;
			this.maskPrev2.x = x1 + gap;
			this.maskPrev2.scaleX = this.maskPrev.scaleX; //(this.gridWidth - (x1 - this.gridX1) - gap)/this.gridWidth;
		} else {
			this.maskPrev.x = x1;
			this.maskPrev.scaleX = 0;
			this.maskPrev2.x = x1;
			this.maskPrev2.scaleX = 0;
		}
		
		if (this.bDot) {
			this.scopeDot1.alpha = 100;
			this.scopeDot1.x = x1;
			this.scopeDot1.y = y1;
		}else{
			this.scopeDot1.graphics.clear();
		}
		//trace("ic = "+_ic+", t = "+t+", v = "+v);
		//trace("aValues1 = "+aValues1);
	}
	
	
	
	public nV2Pix( V ){
		// Convert a voltage to abs pixels on the screen
		let pix = this.gridY1 - this.gridHeight/2 - (((V - this.nVcenter)/this.nVperDiv)/this._nVdivs)*this.gridHeight;
		//trace("In nV2Pix, V = "+V+", gridY1 = "+gridY1+", gridHeight = "+gridHeight+", nVcenter = "+nVcenter+", nVperDiv = "+nVperDiv+", _nVdivs = "+_nVdivs+", pix = "+pix);
		return pix;
	}
	
	public nT2Pix( t ){
		// Convert a time (in sweep) to abs pixels on the screen
		let retval = this.gridX1 + (t/this._tSweep)*this.gridWidth;
		//trace("  In nT2Pix, pix = "+retval+", gridX1 = "+gridX1+", t = "+t+", _tSweep = "+_tSweep+", gridWidth = "+gridWidth);
		return retval;
	}

	
	public createGrid() {
		// Clear and draw the grid and annotation.  All units are in pixels with respect to the main document.
		// Grid origin is the lower left corner.
		let xSpacing:number, ySpacing:number;
		let x1:number, y1:number, i:number, x:number, y:number, w:number, h:number;
		//
		this.scopeGrid.graphics.clear(); 
		//
		//trace("_gridType = "+_gridType);
		if (this._gridType == "None"){
			return;
		}
		xSpacing = this.gridWidth/this.gridDivsX;
		ySpacing = this.gridHeight/this.gridDivsY;
		//
		//trace("Drawing scope grid, color = "+_gridColor);
		if (this._gridType == "Outline"){
			this.scopeGrid.graphics.setStrokeStyle(0.5); // Hairline, pure green, opaque
			this.scopeGrid.graphics.beginStroke(UtilSP.c2rgba(this._gridColor)); // Hairline, pure green, opaque
			this.scopeGrid.graphics.moveTo(this.gridX1, this.gridY1);
			this.scopeGrid.graphics.lineTo(this.gridX1, this.gridY1-this.gridHeight);
			this.scopeGrid.graphics.lineTo(this.gridX1+ this.gridWidth, this.gridY1-this.gridHeight);
			this.scopeGrid.graphics.lineTo(this.gridX1+ this.gridWidth, this.gridY1);
			this.scopeGrid.graphics.lineTo(this.gridX1, this.gridY1);
		}else{
			// Draw the full grid
			this.scopeGrid.graphics.setStrokeStyle(0.5); // Hairline, pure green, opaque
			this.scopeGrid.graphics.beginStroke(UtilSP.c2rgba(this._gridColor)); // Hairline, pure green, opaque
			// Draw vertical lines, bottom to top:
			for (i=0; i<=this.gridDivsX; i++) {
				x1 = this.gridX1 + i*xSpacing;
				this.scopeGrid.graphics.moveTo(x1, this.gridY1);
				this.scopeGrid.graphics.lineTo(x1, this.gridY1-this.gridHeight);
			}
			// Draw horizontal lines, left to right
			for (i=0; i<=this.gridDivsY; i++) {
				y1 = this.gridY1-i*ySpacing;
				this.scopeGrid.graphics.moveTo(this.gridX1, y1);
				this.scopeGrid.graphics.lineTo(this.gridX1 + this.gridWidth, y1);
			}
		}
		// Clear and create the trace movie clips too.
	}
	public clearAllData(){
		this.aValues1 = [];
		this.aValues2 = [];
	}
	public makeDot1(){
		// Now make the scope dot:	
		let dotsize = 5;
		this.scopeDot1.graphics.clear();
		this.scopeDot1.graphics.beginFill(UtilSP.c2rgba(this._dot1Color));
		this.scopeDot1.graphics.moveTo(dotsize, 0);
		this.scopeDot1.graphics.lineTo(0, -dotsize);
		this.scopeDot1.graphics.lineTo(-dotsize, 0);
		this.scopeDot1.graphics.lineTo(0, dotsize);
		this.scopeDot1.graphics.lineTo(dotsize, 0);
		this.scopeDot1.graphics.endFill();
	}   

} // End class